const env = process.env.REACT_APP_ENV;

const PROD_SERVER = 'https://tennis-matches-server.vercel.app';
const DEV_SERVER = 'http://localhost:4000';

const dev = {
    apiBaseHost: DEV_SERVER,
};

const prod = {
    apiBaseHost: PROD_SERVER,
};

const envConfigs = {
    dev,
    prod,
};

const ClientConfig = {
    ...envConfigs[env],
    // Client-side switch for the AI chat tab. The server holds the real kill
    // switch (AI_ENABLED); this just avoids showing a tab that cannot work.
    isChatEnabled: process.env.REACT_APP_CHAT_ENABLED !== 'false',
};

export default ClientConfig;
